import { createContext, useContext, useState } from 'react';

const translations = {
  de: {
    nav: { home: 'Startseite', sour: 'Sour', sweet: 'Sweet', gallery: 'Galerie', contact: 'Kontakt' },
    hero: { title: 'Exquisite Cocktails & Köstliche Desserts', subtitle: 'Zwei Konzepte. Eine Marke. Unvergessliche Events.', cta: 'Jetzt anfragen' },
    about: { title: 'Über Uns', description: 'SourSweet vereint zwei leidenschaftliche Welten unter einem Dach: erfrischende Cocktail-Kreationen und verführerische süße Köstlichkeiten.', sourTitle: 'Sour - Cocktails', sourDesc: 'Professionelle Cocktailbar mit kreativen Kreationen.', sweetTitle: 'Sweet - Desserts', sweetDesc: 'Handgemachte Schokoladen-Erdbeeren und exquisite Desserts.' },
    sour: { title: 'Sour', subtitle: 'Cocktail Catering', description: 'Erleben Sie professionelles Cocktail-Catering auf höchstem Niveau.', features: ['Professionelle Barkeeper', 'Premium Spirituosen', 'Individuelle Cocktailkarten', 'Mobile Cocktailbar'] },
    sweet: { title: 'Sweet', subtitle: 'Dessert Catering', description: 'Verwöhnen Sie Ihre Gäste mit unseren handgemachten Dessert-Kreationen.', features: ['Schokoladen-Erdbeeren', 'Dessert-Variationen', 'Individuelle Kreationen', 'Premium Zutaten'] },
    gallery: { title: 'Galerie', subtitle: 'Einblicke in unsere Arbeit' },
    contact: { title: 'Kontakt', subtitle: 'Reservierung anfragen', description: 'Füllen Sie das Formular aus und wir melden uns bei Ihnen.', form: { name: 'Vollständiger Name', email: 'E-Mail', phone: 'Telefonnummer', guests: 'Anzahl der Gäste', date: 'Bevorzugtes Datum', time: 'Bevorzugte Uhrzeit', eventType: 'Art der Veranstaltung', eventTypes: { sour: 'Sour - Cocktails', sweet: 'Sweet - Desserts', both: 'Beide Konzepte' }, message: 'Besondere Wünsche', submit: 'Anfrage senden', cancel: 'Abbrechen', sending: 'Wird gesendet...', success: 'Vielen Dank! Ihre Anfrage wurde gesendet.', error: 'Ein Fehler ist aufgetreten.' } },
    footer: { contact: 'Kontakt', email: 'E-Mail', rights: 'Alle Rechte vorbehalten.' }
  },
  en: {
    nav: { home: 'Home', sour: 'Sour', sweet: 'Sweet', gallery: 'Gallery', contact: 'Contact' },
    hero: { title: 'Exquisite Cocktails & Decadent Desserts', subtitle: 'Two Concepts. One Brand. Unforgettable Events.', cta: 'Request Now' },
    about: { title: 'About Us', description: 'SourSweet combines two passionate worlds under one roof: refreshing cocktail creations and seductive sweet delicacies.', sourTitle: 'Sour - Cocktails', sourDesc: 'Professional cocktail bar with creative creations.', sweetTitle: 'Sweet - Desserts', sweetDesc: 'Handmade chocolate-covered strawberries and exquisite desserts.' },
    sour: { title: 'Sour', subtitle: 'Cocktail Catering', description: 'Experience professional cocktail catering at the highest level.', features: ['Professional Bartenders', 'Premium Spirits', 'Custom Cocktail Menus', 'Mobile Cocktail Bar'] },
    sweet: { title: 'Sweet', subtitle: 'Dessert Catering', description: 'Treat your guests to our handmade dessert creations.', features: ['Chocolate Strawberries', 'Dessert Variations', 'Custom Creations', 'Premium Ingredients'] },
    gallery: { title: 'Gallery', subtitle: 'Glimpses of Our Work' },
    contact: { title: 'Contact', subtitle: 'Request a Reservation', description: 'Fill out the form and we will get back to you.', form: { name: 'Full Name', email: 'Email', phone: 'Phone Number', guests: 'Number of Guests', date: 'Preferred Date', time: 'Preferred Time', eventType: 'Event Type', eventTypes: { sour: 'Sour - Cocktails', sweet: 'Sweet - Desserts', both: 'Both Concepts' }, message: 'Special Requests', submit: 'Send Request', cancel: 'Cancel', sending: 'Sending...', success: 'Thank you! Your request has been sent.', error: 'An error occurred.' } },
    footer: { contact: 'Contact', email: 'Email', rights: 'All rights reserved.' }
  }
};

const LanguageContext = createContext(null);

// Dil belirleme - URL'den sayfa ismine göre
const getInitialLanguage = () => {
  if (typeof window === 'undefined') return 'de';
  
  const path = window.location.pathname;
  
  // İngilizce sayfalar
  if (path === '/home' || path === '/gallery' || path === '/contact' || 
      path === '/privacy' || path === '/terms' || path === '/imprint') {
    localStorage.setItem('siteLang', 'en');
    return 'en';
  }
  
  // Almanca sayfalar
  if (path === '/startseite' || path === '/galerie' || path === '/kontakt' || 
      path === '/datenschutz' || path === '/agb' || path === '/impressum') {
    localStorage.setItem('siteLang', 'de');
    return 'de';
  }
  
  // /sour ve /sweet için localStorage'dan al (her iki dilde de aynı URL)
  const savedLang = localStorage.getItem('siteLang');
  return (savedLang === 'en' || savedLang === 'de') ? savedLang : 'de';
};

export const LanguageProvider = ({ children }) => {
  const [language] = useState(getInitialLanguage);

  const t = (key) => {
    const keys = key.split('.');
    let value = translations[language];
    for (const k of keys) {
      value = value?.[k];
    }
    return value || key;
  };

  return (
    <LanguageContext.Provider value={{ language, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) throw new Error('useLanguage must be used within LanguageProvider');
  return context;
};
